<template>
<div id="ag-grid-demo">
    <vs-popup class="holamundo" title="New Room Category" :active.sync="popupActivo">

        <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/3 w-full topPad">
                <span class="popup_lbl inputStyles">Category Name</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
                <vs-input class="inputx w-full" v-validate="{ required: true,regex: /^[a-zA-Z .'/]+$/}" name="CategoryName" v-model="form.categoryName" />
                <span class="text-danger text-sm" v-show="errors.has('CategoryName')">{{ errors.first('CategoryName') }}</span>
            </div>
        </div>
        <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/3 w-full topPad">
                <span class="popup_lbl inputStyles">Floor</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
                <vs-input class="inputx w-full" name="Floor" v-model="form.floor" v-validate="'required|numeric'"/>
                <span class="text-danger text-sm" v-show="errors.has('Floor')">{{ errors.first('Floor') }}</span>
            </div>
        </div>
        <div class="vx-row mb-4 popup_btn">
            <vs-button color="primary" type="border" style="margin-right:5px;" @click="saveCategoryMaster()" id="button-with-loading" class="float-center vs-con-loading__container">Save</vs-button>
            <vs-button color="primary" type="border" style="margin-left:5px;" @click="clearFields()">Clear</vs-button>
        </div>
    </vs-popup>
    <vx-card>
        <div class="vx-row">
            <vs-button color="success" style="margin-left:90%;margin-bottom:2%;" type="border" @click="openForm">New</vs-button>

        </div>
        <ag-grid-vue :gridOptions="gridOptions" style="padding-left:2rem;padding-right:2rem" class="ag-theme-material w-100 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="contacts" :floatingFilter="true" @grid-ready="onGridReady" :pagination="true" :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true">
        </ag-grid-vue>
        <vs-pagination style="margin-top:-60px;" :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
    </vx-card>
</div>
</template>

<script>
import {
    AgGridVue
} from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'

export default {
    components: {
        AgGridVue
    },
    data() {
        return {
            popupActivo: false,
            floorList: [{"id":"0","name":"Select"},{"id":"1","name":"2nd"}],
            form: {
                categoryId:"New",
                categoryName: "",
                floor:""
            },
            gridOptions: {
                onFilterChanged: this.onGridReady,
                rowModelType: 'infinite',
                floatingFiltersHeight: 40,
                rowStyle: {
                    'text-align': 'center',
                    'cursor': 'pointer'
                },
                onRowDoubleClicked: this.getCategoryDetail,
                rowSelection: "single",
            },
            maxPageNumbers: 7,
            gridApi: null,
            defaultColDef: {

                resizable: true,
                filter: true,
                suppressMenu: true,
                floatingFilterComponentParams: {
                    suppressFilterButton: true
                },
                filterParams: {
                    newRowsAction: 'keep',
                    browserDatePicker: true
                }
            },
            columnDefs: [{
                    headerName: 'Category ID',
                    field: 'categoryId',
                    filter: true,
                    width: 298,
                    tooltipValueGetter: (params) => {
                        return 'Double click to Edit'
                    },
                    cellStyle: {
                        'text-align': 'center'
                    }
                },
                {
                    headerName: 'Category Name',
                    field: 'categoryName',
                    filter: true,
                    width: 289,
                    tooltipValueGetter: (params) => {
                        return 'Double click to Edit'
                    },
                    cellStyle: {
                        'text-align': 'left'
                    }
                },
                {
                    headerName: 'Floor',
                    field: 'floor',
                    filter: true,
                    width: 365,
                    tooltipValueGetter: (params) => {
                        return 'Double click to Edit'
                    },
                    cellStyle: {
                        'text-align': 'center'
                    }
                },

            ],
            contacts: [{}],
        }
    },

    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize()
            else return 7
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages()
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
                this.onGridReady()
            }
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
    methods: {
        onGridReady(params) {
            this.gridApi.showLoadingOverlay();
            window.addEventListener("resize", function () {
                setTimeout(function () {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
            var request = {
                companyId: this.$session.get('companyId'),
                currentPage: this.gridApi.paginationGetCurrentPage() + 1,
                limit: this.gridApi.paginationGetPageSize(),
                filter: this.gridApi.getFilterModel()
            }
            var datasource = {
                getRows: (params) => {
                    this.$http.post(
                            "getroomCategoryDashboard",
                            JSON.stringify(request), {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        .then(response => {
                            params.successCallback(response.data.data, response.data.recordsTotal);
                            this.gridApi.hideOverlay();
                        });
                }
            }
            this.gridApi.setDatasource(datasource);
        },
        openForm() {
            this.clearFields();
            this.errors.clear();
            this.popupActivo = true;
        },
        getCategoryDetail() {
            this.clearFields();
            this.errors.clear();
            var selectedrow = this.gridApi.getSelectedRows();

            selectedrow.forEach((value) => {
                this.form.categoryName = value.categoryName;
                this.form.floor = value.floor;
                this.form.categoryId = value.categoryId;
            });
            this.popupActivo = true;
        },
        
        saveCategoryMaster() {
            this.$validator.validateAll().then(valid => {
                if (valid) {
                    var request = {
                        companyId: this.$session.get('companyId'),
                        data: this.form
                    }
                    this.buttonLoading();
                    this.$http.post(
                            "saveRoomCategoryMaster",
                            JSON.stringify(request), {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        .then(response => {
                            this.onGridReady();
                            this.popupActivo = false;
                            this.$vs.loading.close("#button-with-loading > .con-vs-loading");
                            document.getElementById('button-with-loading').disabled = false;
                            this.$vs.notify({
                                title: 'Successfully Saved',
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-check',
                                position: 'top-center'
                            })

                        }).catch(error => {
                            this.$vs.notify({
                                title: 'Error Occured While Saving',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-check',
                                position: 'top-center'
                            })
                        })
                }
            });
        },
        clearFields() {
            this.form.categoryName = "";
            this.form.floor = "";
        },
        buttonLoading() {
            document.getElementById('button-with-loading').disabled = true;
            this.$vs.loading({
                background: 'primary',
                color: '#fff',
                container: "#button-with-loading",
                scale: 0.45
            })
        },

    },
}
</script>

<style scoped>
.popup_lbl {
    padding-left: 10%;
}

.popup_btn {
    margin-left: 100px;
    padding-left: 98px;
}
.inputStyles{
    font-size: 11.8px;
    font-weight: 600;
}
.topPad{
    padding-top: 7px;
}
</style>
